// Utility function to filter objects from `list` where the `key` value is not present in `existingList`
export const filterByField = (existingList, list, key) => {
    // Extract the values of the `key` field from the existing list
    const existingValues = existingList.map(item => item[key]);
  
    // Filter out items from the list where the `key` value is already in existingValues
    return list.filter(item => !existingValues.includes(item[key]));
  };
  

  export const filterByFields = (existingList, list, existingKey,listKey) => {
    // Extract the values of the `key` field from the existing list
    const existingValues = existingList.map(item => item[existingKey]);
  
    // Filter out items from the list where the `key` value is already in existingValues
    return list.filter(item => !existingValues.includes(item[listKey]));
  };
  